var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partners-filter"},[_c('h2',[_vm._v(_vm._s(_vm.$t('navigation.partners')))]),_c('div',{staticClass:"partners-filter__search orders-filter_width"},[_c('search',{on:{"searchData":_vm.search}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }